import { apiUrl, s3Credential } from '../utils/constants';
import { DELETE, GET, POST, POST_S3, PUT, PATCH } from './api.service.wrapper';
import { GetAuthUser, GetUserRole } from "../services/auth/auth.service"

const user = GetAuthUser();
let role = GetUserRole();

export const GetProfile = async () => {
    let response = await GET(apiUrl.profile);
    return response;
}

export const UpdateProfile = async (data) => {
    const config = {
        headers: {
            'content-type': 'application/json'
        }
    }
    const response = await PATCH(apiUrl.update_profile, data, config);
    return response;
}
export const GetType = async (enumType = '') => {
    let params = {};

    if (enumType) {
        params['enumType'] = enumType;
    }

    const response = await GET(apiUrl.enum_type, params);
    return response;
}

export const GetTrainerTimeslots = async (id, session_id = '', date = '') => {
    let params = {};

    if (session_id) {
        params['session_id'] = session_id;
    }
    if (date) {
        params['date'] = date;
    }
    const response = await GET(apiUrl.timeslots + '/' + id, params);
    return response;
}

export const GetBreathingVideoByid = async () => {
    const response = await GET(apiUrl.breathing_video);
    return response;
}

export const GetUsers = async (
    email = false,
    searchText = '',
    page = '',
    perPage = '',
    is_paginate = 1,
    status = '',
    subscribed = null, // Changed to null as default
    startDate= null,
    endDate = null
) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }

    if (searchText) {
        params['filter[searchText]'] = searchText;
    }

    if (status) {
        params['status'] = status;
    }

    if (startDate) {
        params['startAt'] = startDate
    }

    if (endDate) {
        params['endAt'] = endDate
    }

    if (is_paginate === 0) {
        params['withoutPagination'] = true;
    }

    // Add the subscribed parameter if it's 0 or 1
    if (subscribed === 0 || subscribed === 1) {
        params['subscribed'] = subscribed;
    }

    const response = await GET(apiUrl.users, params);
    return response;
}

export const GetUserById = async (id) => {
    let response = '';
    response = await GET(apiUrl.userId + '/' + id);
    return response;
}

export const GetTrainerById = async (id) => {
    let response = '';
    response = await GET(apiUrl.trainer + '/' + id);
    return response;
}

export const CreateUser = async (data) => {
    const response = await POST(apiUrl.create_user, data);
    return response;
}

export const UpdateUser = async (id, data) => {
    const config = {
        headers: {
            'content-type': 'application/json'
        }
    }
    const response = await PUT(apiUrl.update_user, id, data, config);
    return response;
}

export const UpdateBreathingVideo = async (id, data) => {
    const response = await PUT(apiUrl.breathing_video, id, data);
    return response;
}

export const UpdateTrainerProfile = async (id, data) => {
    const response = await PUT(apiUrl.trainer, id, data);
    return response;
}

export const UpdateProfilePartial = async (id, data) => {
    const response = await PUT(apiUrl.partial, id, data);
    return response;
}
export const DeleteUser = async (id) => {
    const response = await DELETE(apiUrl.delete_user, id);
    return response;
}

export const ChatNotification = async (data) => {
    const response = await POST(apiUrl.chat_notification, data);
    return response;
}


export const getPresignedPostUrl = async (fileType, fileName) => {
    const config = {
        headers: {
            'x-access-token': s3Credential.app_token
        }
    }
    let response = '';
    response = await POST_S3(apiUrl.get_s3_token, fileType, config);
    return response.data;
}

export const GetRecordCount = async (id) => {
    let params = {}

    if (id) {
        params['filter[userId]'] = id;
    }
    const response = await GET(apiUrl.record_count, params);
    return response;
}